export default __webpack_public_path__ + "instagram-hrz-v1.svg";